import { useState } from "react";
import request from "../../utils/requests";
import logger from "../../utils/logger";
import FormData from "form-data";
import { AxiosError } from "axios";

interface Target {
  target: {
    name: string;
    value: string | number;
  };
}

export const Newsletter = () => {
  const [form, setForm] = useState({ name: "", email: "" });
  const [feedback, setFeedback] = useState<string | null>(undefined);

  const handleSetForm = ({ target: { name, value } }: Target) => {
    setForm((form) => ({ ...form, [name]: value }));
  };

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();

    try {
      if (form.name && form.email) {
        const formData = new FormData();
        formData.append("name", form.name);
        formData.append("email", form.email);

        await request.post("/api/newsletter/subscribe", formData);
        logger.info("Sending newsletter subscription with success!");
        setForm({ name: "", email: "" });
        setFeedback("Sucesso! Obrigado pelo seu cadastro.");
      } else {
        setFeedback("Para enviar, preencha os campos.");
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error.response.status === 409) {
          setFeedback("Seu e-mail ja está cadastrado!");
        }
      } else {
        setFeedback("Ops! Não funcionou, tente novamente mais tarde.");
      }
    }
  };

  return (
    <section className="section newsletter-midpage">
      <div className="row">
        <div className="newsletter">
          <div className="newsletter-txt">
            <h3 className="newsletter-title">
              <span className="ez-toc-section" id="quer_saber_mais" />
              Quer saber mais?
              <span className="ez-toc-section-end" />
            </h3>
            <p className="newsletter-description">
              Assine a nossa newsletter e receba os conteúdos em seu e-mail.
            </p>
          </div>
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <div className="newsletter-group">
              <div className="newsletter-field-full" style={{ height: "60px" }}>
                <input
                  id="name"
                  name="name"
                  type="text"
                  className="newsletter-input"
                  placeholder="Nome"
                  autoComplete="off"
                  value={form.name}
                  onChange={handleSetForm}
                />
              </div>

              <div className="newsletter-field" style={{ height: "60px" }}>
                <input
                  id="email"
                  name="email"
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                  className="newsletter-input"
                  placeholder="E-mail"
                  autoComplete="off"
                  value={form.email}
                  onChange={handleSetForm}
                />
              </div>
              <div className="newsletter-field">
                <button className="newsletter-submit" type="submit">
                  Enviar
                </button>
              </div>
              <span className="newsletter-form-error">{feedback}</span>
            </div>
          </form>
          <img
            className="newsletter-image"
            loading="lazy"
            src="/static-next/imagem_banner.png"
            alt="Newsletter"
          />
        </div>
      </div>
    </section>
  );
};
